import { render, staticRenderFns } from "./DownloadList.vue?vue&type=template&id=78527190&scoped=true"
import script from "./DownloadList.vue?vue&type=script&lang=js"
export * from "./DownloadList.vue?vue&type=script&lang=js"
import style0 from "./DownloadList.vue?vue&type=style&index=0&id=78527190&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78527190",
  null
  
)

export default component.exports